var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingSuccessClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Border"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cross",
    d: "M12 0.25C18.4893 0.25 23.75 5.51065 23.75 12C23.75 18.4893 18.4893 23.75 12 23.75C5.51065 23.75 0.25 18.4893 0.25 12C0.25 5.51065 5.51065 0.25 12 0.25ZM12 1.75C6.33908 1.75 1.75 6.33908 1.75 12C1.75 17.6609 6.33908 22.25 12 22.25C17.6609 22.25 22.25 17.6609 22.25 12C22.25 6.33908 17.6609 1.75 12 1.75ZM15.4697 7.46973C15.7626 7.17683 16.2374 7.17683 16.5303 7.46973C16.8232 7.76262 16.8232 8.23738 16.5303 8.53027L13.0605 12L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L12 13.0605L8.53027 16.5303C8.23738 16.8232 7.76262 16.8232 7.46973 16.5303C7.17683 16.2374 7.17683 15.7626 7.46973 15.4697L10.9395 12L7.46973 8.53027C7.17683 8.23738 7.17683 7.76262 7.46973 7.46973C7.76262 7.17683 8.23738 7.17683 8.53027 7.46973L12 10.9395L15.4697 7.46973Z",
    fill: "#272A34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingSuccessClose);
export default __webpack_public_path__ + "static/media/booking-success-close.2fecc086b590f2d92cb65dcb7c10e312.svg";
export { ForwardRef as ReactComponent };